import { motion, HTMLMotionProps } from 'framer-motion';
import { ReactNode } from 'react';
import { useReducedMotion } from '@/lib/motion/hooks/use-reduced-motion';

interface HoverScaleProps extends Omit<HTMLMotionProps<'div'>, 'children'> {
  children: ReactNode;
  scale?: number;
  className?: string;
  /** Enable tap/click scale down effect */
  tapScale?: boolean;
}

export function HoverScale({
  children,
  scale = 1.02,
  className,
  tapScale = true,
  ...props
}: HoverScaleProps) {
  const reducedMotion = useReducedMotion();

  if (reducedMotion) {
    return <div className={className}>{children}</div>;
  }

  return (
    <motion.div
      whileHover={{ scale, transition: { duration: 0.2, ease: 'easeOut' } }}
      whileTap={tapScale ? { scale: 0.98, transition: { duration: 0.1 } } : undefined}
      className={className}
      {...props}
    >
      {children}
    </motion.div>
  );
}
